var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVs(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 391,
    height: 178,
    viewBox: "0 0 391 178",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60.8 176.096L0.0320001 1.85599H58.208L100.832 123.68L143.168 1.85599H201.344L140.576 176.096H60.8ZM274.082 60.032C274.082 65.792 276.962 68.672 282.722 68.672H339.17C373.346 68.672 390.434 83.84 390.434 114.176V132.032C390.434 162.368 373.346 177.536 339.17 177.536H267.746C233.57 177.536 216.482 162.368 216.482 132.032V119.072H274.082V122.816C274.082 128.576 276.962 131.456 282.722 131.456H324.194C329.954 131.456 332.834 128.576 332.834 122.816V117.632C332.834 111.872 329.954 108.992 324.194 108.992H267.746C233.57 108.992 216.482 93.824 216.482 63.488V46.208C216.482 15.872 233.57 0.703991 267.746 0.703991H339.17C373.346 0.703991 390.434 15.872 390.434 46.208V59.168H332.834V55.424C332.834 49.664 329.954 46.784 324.194 46.784H282.722C276.962 46.784 274.082 49.664 274.082 55.424V60.032Z",
    fill: "white",
    fillOpacity: 0.72
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVs);
export default __webpack_public_path__ + "static/media/VS.b9d5badb1879425d52701403275102bc.svg";
export { ForwardRef as ReactComponent };